export const imageUpload = {
	addImage: "Ajouter une image",
	removeImage: "Supprimer l'image téléchargée",
	formatInfo: "JPG ou PNG",
	ariaLabel: {
		uploadedImage: "Image du produit téléchargée",
	},
};
